<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="courseForm">
        <div class="mt-5">
          <div class="md-6">
            <div class="col-md-12 mb-3">
              <label for="name">Course Name</label>
              <input type="text" class="form-control" formControlName="name" id="name"
                     placeholder="Course Name">
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="startDate">Start Date</label>
                <input
                  ngbDatepicker
                  container="body"
                  type="text"
                  id="startDate"
                  name="startDate"
                  class="form-control"
                  placeholder="dd.mm.yyyy"
                  #sd="ngbDatepicker"
                  firstDayOfWeek="0"
                  formControlName="startDate"
                  (click)="sd.toggle()"
                  (dateSelect)="getSchedules()"
                >
              </div>
              <div class="col-md-6 mb-3">
                <label for="endDate">End Date</label>
                <input
                  ngbDatepicker
                  container="body"
                  type="text"
                  id="endDate"
                  name="endDate"
                  class="form-control"
                  placeholder="dd.mm.yyyy"
                  #ed="ngbDatepicker"
                  firstDayOfWeek="0"
                  formControlName="endDate"
                  (click)="ed.toggle()"
                  (dateSelect)="getSchedules()"
                >
              </div>
            </div>
            <div class="col-md-12" *ngIf="courseForm?.touched && courseForm?.hasError('invalidDateRange')">
              <small class="text-danger">Start Date cannot be later than End Date</small>
            </div>
          </div>
          <div class="md-6">
            <div class="col-md-12">
              <label for="user" class="filter-label" style="width: 100%">
                Select lessons:
              </label>
              <ng-select
                [items]="lessonsScheduleByDates"
                bindLabel="label"
                placeholder="Lessons"
                [searchable]="true"
                [multiple]="true"
                id="user"
                [compareWith]="compareById"
                appendTo="body"
                class="filter"
                formControlName="selectedSchedules"
              />
            </div>
          </div>

          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(courseForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{ errorMessage }}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
